import { useEffect, useMemo, useRef, useState } from "react";
import { IoArrowDownOutline, IoArrowUpOutline } from "react-icons/io5";
import useLogicalProducts from "../../../hooks/useLogicalProducts";
import { getImageUrl } from "../../../utils";
import { TrendingProducts } from "../../Widgets/Banner";
import ProductCard from "../ProductCard";
import ShowMoreButton from "../ShowMoreButton";
import classes from "./TrendingProducts.module.css";

const TrendingProductsComp = ({ widget }: { widget?: any }) => {
	const mainRef = useRef(null);
	const pcRef = useRef(null);

	const leftWidgetData = useMemo(() => {
		return {
			...widget,
			data: {
				...widget?.data,
				setting: {
					custom: widget?.data?.leftProducts?.custom,
					logical: widget?.data?.leftProducts?.logical,
				},
			},
		};
	}, [widget]);

	const mainWidgetData = useMemo(() => {
		return {
			...widget,
			data: {
				...widget?.data,
				setting: {
					custom: widget?.data?.mainProducts?.custom,
					logical: widget?.data?.mainProducts?.logical,
				},
			},
		};
	}, [widget]);

	const {
		products: leftProducts,
		loading: leftLoading,
		error: leftError,
	} = useLogicalProducts({ widget: leftWidgetData as any });

	const {
		products: mainProducts,
		loading: mainLoading,
		error: mainError,
	} = useLogicalProducts({ widget: mainWidgetData as any });

	const [containerHeight, setContainerHeight] = useState(0);

	const featuredImage = widget?.data?.featuredImage;

	useEffect(() => {
		const calcHeight = () => {
			if (pcRef.current) {
				const target = pcRef.current as HTMLDivElement;
				const height = target.clientHeight;
				setContainerHeight(height);
			}
		};

		calcHeight();

		setTimeout(calcHeight, 600);
		setTimeout(calcHeight, 3000);

		window.addEventListener("resize", calcHeight);

		return () => {
			window.removeEventListener("resize", calcHeight);
		};
	}, [pcRef, mainProducts, leftProducts, leftLoading, mainLoading]);

	const settings = widget?.data?.settings || {};

	if (
		leftLoading ||
		mainLoading ||
		!leftProducts.length ||
		!mainProducts.length
	)
		return <TrendingProducts />;

	return (
		<section ref={mainRef} className={`${classes.TrendingProducts}`}>
			<div className="container lg:flex gap-2">
				{(leftProducts?.length > 0 || leftLoading) && (
					<div className={classes.left}>
						<div className={classes.header}>
							<h2 className={classes.title}>Latest Products</h2>

							<div className={classes.buttons}>
								<button
									className={classes.button}
									id="swiper-button-next-trending-321">
									<IoArrowUpOutline
										className={classes.icon}
									/>
								</button>

								<button
									className={classes.button}
									id="swiper-button-prev-trending-321">
									<IoArrowDownOutline
										className={classes.icon}
									/>
								</button>
							</div>
						</div>

						{/* {leftLoading && <ProductColumnSkeleton />} */}

						{leftProducts?.length > 0 && (
							<div className={classes.slider}>
								{leftProducts
									?.slice(0, 5)
									?.map((product, i) => (
										<ProductCard
											productItem={product}
											settings={settings}
											key={i}
											size="xs"
										/>
									))}
							</div>
						)}
					</div>
				)}

				<div className={classes.right}>
					<div className={classes.header}>
						<h2 className={classes.title}>Trending Products</h2>

						<div className={classes.buttons}>
							<ShowMoreButton type="all" />
						</div>
					</div>

					<div ref={pcRef} className={classes.body}>
						<div className={classes.products}>
							{mainProducts?.slice(0, 4).map((product, i) => (
								<ProductCard
									key={i}
									productItem={product}
									settings={settings}
								/>
							))}
						</div>

						<div className={classes.banner}>
							<img
								src={getImageUrl(featuredImage?.image || "")}
								alt="banner"
								style={{
									aspectRatio: 985 / 145,
									objectFit: "cover",
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TrendingProductsComp;
